'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/2221
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var objectValues = Object.values || function (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};
exports.default = objectValues;


//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/objectValues.js
// module id = 27
// module chunks = 0